import React, { useEffect, useState } from 'react';
import { campaignManagementService } from 'services/campaign';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import ShortlistedLeadsSidebar from './ShortListedSiderbar';
import ShortlistedLeadsSidebarSkeleton from '../PreLoadSkeletons/ShortListedLeadsSidebarSkeleton';
import { Batch } from "../../../types";


const ShortlistedLeadsContainer: React.FC<{
  setBatchIDChild: (stype: string) => void;
  batches: Batch[];
}> = ({setBatchIDChild, batches}) => {
  const expertId = useSelector((state: RootState) => state.auth.user.expertId);

  //if (loading) return <ShortlistedLeadsSidebarSkeleton />;
  return  <ShortlistedLeadsSidebar batches={batches} setBatchIDChild={setBatchIDChild} />;
};

export default ShortlistedLeadsContainer;
